<!--
	SummaryCardGroup: lays out a dashboard's three SummaryCards as one joined strip, stacked below
	1400px and side by side above it, with the middle card raised.
-->
<script lang="ts">
	import type { Snippet } from 'svelte';

	const { children }: { children: Snippet } = $props();
</script>

<div class="summaryCardGroup">
	{@render children()}
</div>

<style>
	.summaryCardGroup {
		display: flex;
		isolation: isolate;
		flex-direction: column;
		align-items: center;
		margin-block: var(--space-4);

		> :global(article) {
			width: min(100%, 30rem);
		}

		> :global(article:first-child) {
			border-radius: var(--radius) var(--radius) 0 0;
		}

		> :global(article:nth-child(2)) {
			position: relative;
			z-index: 1;
			box-shadow: var(--shadow-lg);
			border-color: var(--border-strong);
			width: min(100%, 32rem);
			min-height: 33.5rem;
		}

		> :global(article:last-child) {
			border-radius: 0 0 var(--radius) var(--radius);
		}

		@media screen and (min-width: 1300px) {
			flex-direction: row;

			> :global(article) {
				width: 26rem;
			}

			> :global(article:first-child) {
				border-radius: var(--radius) 0 0 var(--radius);
			}

			> :global(article:last-child) {
				border-radius: 0 var(--radius) var(--radius) 0;
			}
		}
	}
</style>
